import { useEffect } from 'react';
import { useUser } from '@contexts/UserContext';
import { useAppDispatch, useAppSelector } from '@store';
import { fetchFiles, clearFiles } from '@store/slices/filesSlice';

export const FilesInitializer = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const isLoadingFiles = useAppSelector((state) => state.files.isLoading);
  const hasFetched = useAppSelector((state) => state.files.hasFetched);

  useEffect(() => {
    const username = user?.username;

    // Clear files when user logs out
    if (!username) {
      dispatch(clearFiles());
      return;
    }

    // Fetch files when user is available and we haven't fetched yet
    if (!hasFetched && !isLoadingFiles) {
      dispatch(fetchFiles(username));
    }
  }, [user?.username, hasFetched, isLoadingFiles, dispatch]);

  return null;
};
